module.exports = {
      id: "close-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#close",
      toString: function () {
        return this.url;
      }
    }